import { GeometricLinearElement } from "../../GeometricLinearElement";
import { IStructureElement, RepairCategories, RepairTypes } from "./IStructureEleement";
import { StructuralElement } from "./StructuralElement";
import type { Mesh, Material } from '@phdsoft/three';

// export interface LinearElement extends StructuralElement {

// }

// export class LinearElement extends GeometricLinearElement implements IStructureElement {
export class LinearElement extends StructuralElement implements IStructureElement {
    public VerifyProperties() {
        throw new Error("Method not implemented.");
    }
    Weight?: number;
    Volume?: number;
    OnFrontSide?: boolean;
    StrakeColor?: string;
    RepairCategory?: RepairCategories;
    RepairTypes?: RepairTypes;
    RenewalFactor?: number;


      //#region Degradation

      SubstantialCorrosionThickness?: number;
      ExcessiveCorrosionThickness?: number;
      AbsoluteDegradation?: number;
      RelativeDegradation?: number;
      CorrosionRate?: number;
      RemainingLife?: number;
      EstimatedThickness?: number;
      CorrosionRiskIndex?: number;

    //#endregion

    public get isFlange() : boolean {
        return this.properties.Geometry.FlangeThickness > 0;
    }

    constructor(mesh?: Mesh, material?: Material, id?: string) {
        super(mesh, material, id);
        // mesh.visible = false;
        this.Guid = mesh?.userData.Guid;
        this.regionId = mesh?.userData.RegionId;
        this.SectionId = mesh?.userData.SectionID;
        this.elementTypeName = 'LinearElement';
        this.regionIds = mesh?.userData.RegionIds;
        this.TypeId = mesh?.userData.TypeId;
        this.fullIdElements = [];
        this.completeIdElements = [];
        this.deleteUserDataValues(mesh);
    }

    ComputeMaximumDegradationRate(): number {
        throw new Error("Method not implemented.");
    }
    GetDegradationStatus(): string {
        throw new Error("Method not implemented.");
    }
    GetDegradationColor(): string {
        throw new Error("Method not implemented.");
    }
    ComputeAverageOfPoints(): void {
        throw new Error("Method not implemented.");
    }
    ComputeMinimumRemainingLife(): number {
        throw new Error("Method not implemented.");
    }
    ComputeMaximumRelativeDegradation(): number {
        throw new Error("Method not implemented.");
    }

    private deleteUserDataValues(mesh: Mesh): void {
        if (mesh) {
            delete mesh.userData.Guid;
            delete mesh.userData.RegionId;
            delete mesh.userData.SectionID;
            delete mesh.userData.RegionIds;
            delete mesh.userData.TypeId;
            delete mesh.userData.Area;
            delete mesh.userData.BackCompartmentID;
            delete mesh.userData.Boundaries;
            delete mesh.userData.Class;
            delete mesh.userData.CoupledLinearElementIds;
            delete mesh.userData.FrontCompartmentID;
            delete mesh.userData.Label;
            delete mesh.userData.Line;
            delete mesh.userData.PointsValues;
            delete mesh.userData.Type;
            delete mesh.userData.tolerance;
        }
    }

    public clone(): LinearElement {
        var clone = new LinearElement();
        clone.Guid = this.Guid;
        clone.regionId = this.regionId;
        clone.SectionId = this.SectionId;
        clone.regionIds = this.regionIds;
        clone.TypeId = this.TypeId;
        clone.properties = JSON.parse(JSON.stringify(this.properties));
        clone.thickness = this.thickness;
        clone.MaterialType = this.MaterialType;
        clone.MaterialSubType = this.MaterialSubType;
        // clone.SectionId =
        return clone;
    }

    
    private _fullIdElements : Array<LinearElement>;
    public get fullIdElements() : Array<LinearElement> {
        return this._fullIdElements;
    }
    public set fullIdElements(v : Array<LinearElement>) {
        this._fullIdElements = v;
    }

    private _completeIdElements : Array<LinearElement>;
    public get completeIdElements() : Array<LinearElement> {
        return this._completeIdElements;
    }
    public set completeIdElements(v : Array<LinearElement>) {
        this._completeIdElements = v;
    }
    
    private _length : number;
    public get length() : number {
        return this._length;
    }
    public set length(v : number) {
        this._length = v;
    }
      
}
